import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { httpRequest } from 'utils/httpRequest';
import { Pagination } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { toast } from 'react-toastify';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';


const AdditionalResources = () => {

    const { loading, startLoading, stopLoading } = useLoader()

    const [additionalResourceData, setAdditionalResourceData] = useState([])
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState(0);

    const [data, setData] = useState([
        { id: 1, name: 'John Doe', Link: "http://www.google.com", },
        { id: 2, name: 'Jane Smith', Link: "http://www.facebook.com", },
        { id: 3, name: 'Mike Johnson', Link: "http://www.instagram.com", },
        { id: 4, name: 'Sarah Wilson', Link: "http://www.countryshow.com", },
        { id: 5, name: 'Tom Brown', Link: "http://www.meta.com", },
        { id: 6, name: 'Lisa Davis', Link: "http://www.oracle.com", },
        { id: 7, name: 'Mark Taylor', Link: "http://www.newton.com", },
    ]);


    const navigate = useNavigate();

    //pagination
    const handlePageChange = (page) => {
        setActivePage(page);
        fetchAdditionalResourceData(page, limit);
    };

    //pagination



    const handleDelete = async (id) => {
        try {

            const response = await httpRequest(
                `resource/delete/${id}`,
                "DELETE",
                {},
                {},
                true,
                false
            );

            if (response?.code === 200) {
                toast.success("Resource deleted successfully.")
                const newTotal = total - 1;
                const maxPages = Math.ceil(newTotal / limit);
                const newPage = activePage > maxPages ? maxPages : activePage;

                setTotal(newTotal); // optional
                setActivePage(newPage);
                fetchAdditionalResourceData(newPage, limit)

            }

        } catch (error) {
            console.log(error);
            toast.error("Something went wrong")
        }
    };


    const handleNavigationOnAddResources = () => {
        navigate("/admin/add-link");
    }




    const fetchAdditionalResourceData = async (page = 1, pageLimit = 10) => {
        startLoading()
        try {

            const response = await httpRequest(
                `resource/list`,
                "GET",
                {

                },
                {
                    page: page,
                    limit: pageLimit
                },
                true,
                false
            );

            if (response?.code === 200) {
                setAdditionalResourceData(response?.data)
                setTotal(response?.total);
                setActivePage(response?.page);
                setLimit(response?.limit);


            }

        } catch (error) {
            console.log(error);
        }finally{
            stopLoading()
        }
    }





    useEffect(() => {
        fetchAdditionalResourceData(activePage, limit)
    }, [])










    return (
        <>


        {loading ? <CircleLoader/> :(   <div className="container-fluid py-4 mt-5">
                <div className="row">
                    <div className="col">
                        <div className="card shadow">
                            {/* Card Header */}
                            <div className="card-header border-0 d-flex justify-content-end">
                                <h3 className="mb-0 mr-auto">Additional Resources</h3>
                                <Button color="primary" size="sm" onClick={handleNavigationOnAddResources}>
                                    Add Link
                                </Button>
                            </div>

                            {/* Table */}
                            <div className="table-responsive">
                                <table className="table align-items-center table-flush">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col">S.No</th>
                                            <th scope="col">Link</th>
                                            <th scope="col">Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {additionalResourceData && additionalResourceData.length > 0 && additionalResourceData.map((item, index) => (
                                            <tr key={item._id}>

                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                    {(activePage - 1) * limit + index + 1}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="mb-0 text-sm font-weight-bold">
                                                        {item?.link}
                                                    </span>
                                                </td>


                                                <td>
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item._id)}
                                                        title="Delete"
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Card Footer with Pagination */}
                            <div className="card-footer py-4">
                                <div className="d-flex justify-content-end">
                                    <Pagination
                                        size="sm"
                                        total={total}
                                        limit={limit}
                                        activePage={activePage}
                                        onChangePage={handlePageChange}
                                        maxButtons={5}
                                        prev
                                        next
                                        last
                                        first
                                        ellipsis
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>)}



        </>
    );
};

export default AdditionalResources;